export const waitFor = (predicate, timeout) => {
    return new Promise((resolve, reject) => {
        const check = () => {
            if (!predicate()) return;
            clearInterval(interval);
            resolve();
        };
        const interval = setInterval(check, 100);
        check();

        if (!timeout) return;
        setTimeout(() => {
            clearInterval(interval);
            reject();
        }, timeout);
    });
}